import HttpClient from "../../clients/HttpClient";
import { tspKeyEnum, TspKeyType } from "../../models/tspKeyEnum";

export default class TspVoucherService {
  static httpClient: HttpClient = HttpClient.getInstance("backend", process.env.REACT_APP_API_URL);

  public static async uploadVoucherCodes(tspKey: tspKeyEnum, file: File): Promise<boolean> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await this.httpClient.call('POST', `/tsp_vouchers/${tspKey}/create`, formData, {}, {
      'Content-Type': 'multipart/form-data',
    }, false);
    return res.status >= 200 && res.status < 300;
  }

  public static async downloadBillingData(tspKey: TspKeyType, startDate: Date, endDate: Date): Promise<Blob> {
    const payload = {
      startDate: startDate,
      endDate: endDate,
    }
    const res = await this.httpClient.post(`/tsp_vouchers/${tspKey}/billing_data`, payload, true);
    if (res.status < 200 || res.status >= 300) {
      return null;
    }
    const blob = new Blob([res.data])
    return blob;
  }
}
